// extracted by css-extract-rspack-plugin
export default {"icon":"DeleteColumn__icon--Squ04","disabled":"DeleteColumn__disabled--zvWCa","container":"DeleteColumn__container--L0fp1","attention":"DeleteColumn__attention--r3LPX"};